import { GetAdviserListService, GetAdviserListBySearchBarService } from "../Infrastructure/Adviser.service";

export async function GetAdviserListLogic(zone) {
  return await GetAdviserListService(zone);
}

export async function GetAdviserListBySearchBarLogic(zone, name){
  return await GetAdviserListBySearchBarService(zone, name);
}